<script lang="ts" setup>
defineProps<{ title: string }>();

const { t } = useI18n();

const visible = ref(false);
</script>

<template>
  <Button @click="visible = true" icon="pi pi-question-circle" text rounded class="w-1.5rem h-1.5rem" />

  <Dialog
    :header="title"
    style="width: 460px"
    v-model:visible="visible"
    dismissable-mask
    :base-z-index="5"
    :draggable="false"
    modal
  >
    <div class="text-900 text-sm whitespace-pre-wrap">
      <slot />
    </div>

    <template #footer>
      <Button :label="t('close')" icon="pi pi-times" autofocus @click="visible = false" />
    </template>
  </Dialog>
</template>
<i18n>
en:
  close: Close

ru:
  close: Закрыть

de:
  close: Schließen

es:
  close: Cerca

fr:
  close: Fermer
</i18n>
